import React, { Component, useState } from 'react';

import Markdown from '../../atoms/Markdown/Markdown';
import Checkbox from '../../atoms/Checkbox/Checkbox';

// import './BootstrapGrid.css'
// import './BootstrapForms.css'
// import './ApplicationForm.css'

import {
  AppForm,
  TwoColumnRow,
  FirstColumn,
  SecondColumn,
  FormStepTitle,
  FormSectionTitle,
  ApplicationFormLabel,
  ApplicationFormInput,
  SelectInputContainer,
  SelectInput,
  ApplicationFormSubmitButton,
  ApplicationFormLine,
  RequiredAsterisk,
  FormLabel,
  StepNavigationContainer,
  StepNavigationBackButton,
  StepNavigationNextButton,
  Step1Container,
  Step2Container,
  ErrorContainer,
  Step3Container,
  TutitionScheduleGrid,
  TutitionColumnOne,
  TutitionColumnTwo,
  SubmitButton,
} from './ApplicationForm.css.js';

class ApplicationForm extends Component {
  state = {
    currentStep: 1,
    formErrors: null,
    formValues: {
      childName: '',
      childBirthMonth: '',
      childBirthDay: '',
      childBirthYear: '',
      enrollmentDateMonth: '',
      enrollmentDateDay: '',
      enrollmentDateYear: '',
      scheduleChoices: [],
    },
  }

  renderFormTitle = () => {
    const { currentStep } = this.state;

    return (
      <React.Fragment>
        {this.state.currentStep === 1 && (
          <FormStepTitle className={`current-step-${currentStep}`}>step 1: child information</FormStepTitle>
        )}

        {this.state.currentStep === 2 && (
          <FormStepTitle className={`current-step-${currentStep}`}>step 2: parent/guardian information</FormStepTitle>
        )}

        {this.state.currentStep === 3 && (
          <FormStepTitle className={`current-step-${currentStep}`}>step 3: pre-registration/tuition & terms</FormStepTitle>
        )}
      </React.Fragment>
    )
  };

  renderStep1 = () => {
    const { currentStep } = this.state;
    const { childName, childBirthMonth, childBirthDay, childBirthYear, enrollmentDateMonth, enrollmentDateDay, enrollmentDateYear, scheduleChoices } = this.state.formValues;

    const scheduleChoiceCheckboxesObjects = [{
      id: `mce-group[15565]-15565-0`,
      label: `5 Mornings (8am-11:30am)`,
      name: `group[15565][1]`,
      value: `1`,
    }, {
      id: `mce-group[15565]-15565-1`,
      label: `5 Days (8am-3:30pm)`,
      name: `group[15565][2]`,
      value: `2`,
    }, {
      id: `mce-group[15565]-15565-2`,
      label: `5 Extended Days (8am-6pm)`,
      name: `group[15565][4]`,
      value: `4`,
    }];

    const scheduleChoiceCheckboxes = scheduleChoiceCheckboxesObjects.map((checkboxDataItem) =>
      <Checkbox
        id={checkboxDataItem.id}
        label={checkboxDataItem.label}
        name={checkboxDataItem.name}
        value={checkboxDataItem.value}
        groupName={`schedule-choice-group`}
      />
    );

    console.log(`>>>>>>>>>>>> renderStep1 > currentStep: ${currentStep}`);

    return (
      <Step1Container className={currentStep === 1 ? 'show' : 'hide'}>
        <FormSectionTitle>Child's Personal Information</FormSectionTitle>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-CHILDSNAME">Child's Name&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <ApplicationFormInput type="text" className="textfield" id="mce-CHILDSNAME" name="CHILDSNAME" placeholder="" data-validate="required" data-error-message="Please enter a name for your child." />
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel className="col-sm-4 control-label" for="mce-MMERGE9-month">Child's Birth Date&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <span className="subfield monthfield">
              <ApplicationFormInput
                className="datepart datemonth"
                type="text"
                pattern="^(0?[1-9]|1[012])$"
                data-validate="required"
                data-error-message="Please enter a birth month for your child."
                placeholder="MM"
                size="2"
                maxlength="2"
                name="MMERGE9[month]"
                id="mce-MMERGE9-month"
              />
            </span> /
            <span className="subfield dayfield"><ApplicationFormInput className="datepart dateday" type="text" pattern="^(0?[1-9]|1[0123456789]|2[0123456789]|3[01])$" data-validate="required" data-error-message="Please enter a birth day for your child." placeholder="DD" size="2" maxlength="2" name="MMERGE9[day]" id="mce-MMERGE9-day" /></span> /
            <span className="subfield yearfield"><ApplicationFormInput className="datepart dateyear" type="text" pattern="^(19|2[0-9])\d{2}$" data-validate="required" data-error-message="Please enter a birth year for your child." placeholder="YYYY" size="4" maxlength="4" name="MMERGE9[year]" id="mce-MMERGE9-year" /></span>
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-MMERGE12" className="col-sm-4 control-label">Child's Gender&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <SelectInputContainer>
              <SelectInput id="mce-MMERGE12" name="MMERGE12" data-validate="required" data-error-message="Please select a gender for your child.">
                <option selected value="0">Select a Gender</option>
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </SelectInput>
            </SelectInputContainer>
          </SecondColumn>
        </TwoColumnRow>

        <FormSectionTitle>Child's Enrollment Information</FormSectionTitle>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel className="col-sm-4 control-label" for="mce-MMERGE11-month">Earliest Desired Enrollment Date <RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <span className="subfield monthfield"><ApplicationFormInput className="datepart datemonth" type="text" pattern="^(0?[1-9]|1[012])$" data-validate="required" data-error-message="Please enter an enrollment month for your child." placeholder="MM" size="2" maxlength="2" name="MMERGE11[month]" id="mce-MMERGE11-month" /></span> /
            <span className="subfield dayfield"><ApplicationFormInput className="datepart dateday" type="text" pattern="^(0?[1-9]|1[0123456789]|2[0123456789]|3[01])$" data-validate="required" data-error-message="Please enter an enrollment day for your child." placeholder="DD" size="2" maxlength="2" name="MMERGE11[day]" id="mce-MMERGE11-day" /></span> /
            <span className="subfield yearfield"><ApplicationFormInput className="datepart dateyear" type="text" pattern="^(19|2[0-9])\d{2}$" data-validate="required" data-error-message="Please enter an enrollment year for your child." placeholder="YYYY" size="4" maxlength="4" name="MMERGE11[year]" id="mce-MMERGE11-year" /></span>
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel className="col-sm-4 control-label" for="mce-MMERGE9-month">Select Schedule Choice <RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            {scheduleChoiceCheckboxes}
          </SecondColumn>
        </TwoColumnRow>
      </Step1Container>
    );
  }

  renderStep2 = () => {
    const { currentStep } = this.state;

    console.log(`>>>>>>>>>>>> renderStep2 > currentStep: ${currentStep}`);

    return (
      <Step2Container className={currentStep === 2 ? 'show' : 'hide'}>
        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-PRIMARYPAR">Parent/Guardian's Name&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <ApplicationFormInput type="text" className="textfield" id="mce-PRIMARYPAR" name="PRIMARYPAR" placeholder="" data-validate="required" data-error-message="Please enter a parent/guardian name." />
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-MMERGE13-relationship" className="col-sm-4 control-label">Relationship to Child&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <SelectInputContainer>
              <SelectInput id="mce-MMERGE13-relationship" name="MMERGE13[relationship]" data-validate="required" data-error-message="Please enter a your relationship with the child.">
                <option value="">Select One</option>
                <option value="Mother">Mother</option>
                <option value="Father">Father</option>
                <option value="Guardian">Guardian</option>
                <option value="Other">Other</option>
              </SelectInput>
            </SelectInputContainer>
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-EMAIL">Email&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <ApplicationFormInput
              type="email" 
              className="textfield" 
              id="mce-EMAIL" 
              name="EMAIL" 
              placeholder=""
              pattern='([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})'
              data-validate="required" 
              data-error-message="Please enter a parent/guardian email."
            />
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-MMERGE7">Home Phone&nbsp;</FormLabel>
          </FirstColumn>

          <SecondColumn>
            <ApplicationFormInput type="tel" className="textfield" id="mce-MMERGE7" name="MMERGE7" placeholder="" />
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-MMERGE8">Mobile Phone&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
          </FirstColumn>

          <SecondColumn>
            <ApplicationFormInput type="tel" className="textfield" id="mce-MMERGE8" name="MMERGE8" placeholder="" data-validate="required" data-error-message="Please enter a parent/guardian mobile number." />
          </SecondColumn>
        </TwoColumnRow>

        <TwoColumnRow>
          <FirstColumn>
            <FormLabel for="mce-MMERGE10">Work Phone&nbsp;</FormLabel>
          </FirstColumn>

          <SecondColumn>
            <ApplicationFormInput type="tel" className="textfield" id="mce-MMERGE10" name="MMERGE10" placeholder="" />
          </SecondColumn>
        </TwoColumnRow>
      </Step2Container>
    );
  }

  renderStep3 = () => {
    const { step3RefundTitle, step3RefundBody, step3DiscountTitle, step3DiscountBody, step3TuitionTitle, step3TuitionColumn1, step3TuitionColumn2, step3SignatureTermsTitle, step3SignatureTermsBody } = this.props.page;
    const { currentStep } = this.state;

    return (
      <Step3Container className={currentStep === 3 ? 'show' : 'hide'}>
        {!!step3RefundTitle && (<h3>{step3RefundTitle}</h3>)}
        {!!step3RefundBody && (<Markdown body={step3RefundBody} />)}

        {!!step3DiscountTitle && (<h3>{step3DiscountTitle}</h3>)}
        {!!step3DiscountBody && (<Markdown body={step3DiscountBody} />)}

        {!!step3TuitionTitle && (<h3>{step3TuitionTitle}</h3>)}
        <TutitionScheduleGrid>
          {!!step3TuitionColumn1 && (<TutitionColumnOne><Markdown body={step3TuitionColumn1} /></TutitionColumnOne>)}
          {!!step3TuitionColumn2 && (<TutitionColumnTwo><Markdown body={step3TuitionColumn2} /></TutitionColumnTwo>)}
        </TutitionScheduleGrid>

        {!!step3SignatureTermsTitle && (<h3>{step3SignatureTermsTitle}</h3>)}
        {!!step3SignatureTermsBody && (<Markdown body={step3SignatureTermsBody} />)}

        <h3>Signature</h3>
        <FormLabel className="col-sm-4 control-label" for="mce-MMERGE9-month">Full Name&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>
        <ApplicationFormInput type="text" className="textfield" id="mce-FULLNAME" name="FULLNAME" placeholder="" data-validate="required" data-error-message="Please enter your full name as a signature for this application." />
        <p className="help-block">Typing out your fullname will constitute a signature of this application.</p>

        <FormLabel className="col-sm-4 control-label" for="mce-MMERGE9-month">Today's Date&nbsp;<RequiredAsterisk>*</RequiredAsterisk></FormLabel>

        <div>
          <span className="subfield monthfield">
            <ApplicationFormInput
              className="datepart datemonth"
              type="text"
              pattern="^(0?[1-9]|1[012])$"
              data-validate="required"
              data-error-message="Please enter today's month for your signature."
              placeholder="MM"
              size="2"
              maxlength="2"
              name="DDATE[month]"
              id="mce-DDATE-month"
            />
          </span> /
            <span className="subfield dayfield"><ApplicationFormInput className="datepart dateday" type="text" pattern="^(0?[1-9]|1[0123456789]|2[0123456789]|3[01])$" data-validate="required" data-error-message="Please enter today's day for your signature." placeholder="DD" size="2" maxlength="2" name="DDATE[day]" id="mce-DDATE-day" /></span> /
            <span className="subfield yearfield"><ApplicationFormInput className="datepart dateyear" type="text" pattern="^(19|2[0-9])\d{2}$" data-validate="required" data-error-message="Please enter today's year for your signature." placeholder="YYYY" size="4" maxlength="4" name="DDATE[year]" id="mce-DDATE-year" /></span>
        </div>
      </Step3Container>
    );
  }

  renderStepNavigation = () => {
    const handleBackButton = (e) => {
      e.preventDefault();
      this.setState({ currentStep: this.state.currentStep - 1 });
    };

    const handleFormValidation = () => {
      const requiredInputs = document.querySelectorAll(`[data-validate="required"]`);
      const inputErrors = [];

      requiredInputs.forEach((item) => {
        // check if the item has a value and if its visible, if not it might be for another step.
        const isItemVisible = (item.offsetParent !== null);

        // let's see if the input has a regex pattern
        const regex = item.getAttribute(`pattern`);
        const isRegexValid = (!!regex) ? RegExp(regex).test(item.value) : true;

        if ((!item.value || item.value === `0` || !isRegexValid) && isItemVisible) {
          inputErrors.push(item.getAttribute('data-error-message'));

          switch (item.type) {
            case `select`:
              item.parentElement.classList.add(`error`);
              break;
            default:
              item.classList.add(`error`);
          }
        } else {
          switch (item.type) {
            case `select`:
              item.parentElement.classList.remove(`error`);
              break;
            default:
              item.classList.remove(`error`);
          }
        }
      });

      // special case for checking validation on checkboxes and the group
      let isGroupValid = false;
      const requiredCheckboxGroup = document.querySelectorAll(`[data-group-name="schedule-choice-group"]`);

      requiredCheckboxGroup.forEach((checkbox) => {
        if (checkbox.checked) {
          isGroupValid = true;
        }
      });

      if (!isGroupValid) {
        inputErrors.push(`Please make one selection of a schedule that you are interested in for your child.`);
      }

      return inputErrors;
    };

    const handleNextButton = (e) => {
      const inputErrors = handleFormValidation();

      if (inputErrors.length === 0) {
        e.preventDefault();
        this.setState({ formErrors: null });
        console.log(`Set currentStep: ${this.state.currentStep + 1}`);
        this.setState({ currentStep: this.state.currentStep + 1 });
      } else {
        e.preventDefault()
        this.setState({ formErrors: inputErrors });
      }
    };

    const handleSubmitButton = (e) => {
      const inputErrors = handleFormValidation();
      
      if (inputErrors.length === 0) {
        // e.preventDefault();
        this.setState({ formErrors: null });
        // document.getElementById('mc-embedded-subscribe-form').submit();
      } else {
        e.preventDefault()
        this.setState({ formErrors: inputErrors });
      }
    };

    return (
      <StepNavigationContainer>
        <StepNavigationBackButton
          className={`Button ${this.state.currentStep === 1 ? 'hide' : ''}`}
          onClick={handleBackButton}
        >
          back
        </StepNavigationBackButton>

        <StepNavigationNextButton
          className={`Button ${this.state.currentStep === 3 ? 'hide' : ''}`}
          onClick={handleNextButton}
        >
          next
        </StepNavigationNextButton>

        <SubmitButton
          className={`Button ${this.state.currentStep !== 3 ? 'hide' : ''}`}
          type='submit'
          onClick={handleSubmitButton}
        >
          Let's Go! Apply Now!
        </SubmitButton>
      </StepNavigationContainer>
    );
  }

  renderFormErrors = () => {
    const { formErrors } = this.state;

    if (!!formErrors) {
      const errors = formErrors.map((error) =>
        <h5>{error}</h5>
      );

      return (
        <ErrorContainer>
          {errors}
        </ErrorContainer>
      );
    }
  }

  render() {
    const { currentStep, formErrors } = this.state;
    const name = 'Application Form';
    const subject = ''; // optional subject of the notification email
    const action = '';

    return (
      <div className="ce-application-container">
        <div className="container">
          <AppForm
            className={`validate current-step-${currentStep}`}
            action="//huntersbrooklyn.us7.list-manage.com/subscribe/post?u=4cfd147e657e3f4dac7b77cca&amp;id=94730522ec"
            id="mc-embedded-subscribe-form"
            method="post"
            name="mc-embedded-subscribe-form"
            novalidate=""
            target="_self"
          >
            {this.renderFormTitle()}

            {!!formErrors && this.renderFormErrors()}

            {this.renderStep1()}

            {this.renderStep2()}

            {this.renderStep3()}

            {this.renderStepNavigation()}
          </AppForm>
        </div>
      </div>
    );
  }
}

export default ApplicationForm;


